import { PolicySaveRestriction } from '../redux/saveButtonSlice/types.save';
import { translateFn } from '../../../../utils/translator.helper';

export function getSaveRestrictionMessage(restriction: PolicySaveRestriction): string {
  switch (restriction) {
    case PolicySaveRestriction.DEFAULT_POLICY:
      return translateFn('Cannot save this policy because this is the default policy.');
    case PolicySaveRestriction.OTHER_USER:
      return translateFn(' Cannot save this policy because it was created by another user.');
    case PolicySaveRestriction.OTHER_COMPANY:
      return translateFn('Cannot save this policy because it belongs to another company.');
    case PolicySaveRestriction.NO_WRITE_RIGHTS:
      return translateFn('Cannot save this policy because of insufficient rights.');
    default:
      return '';
  }
}
